export default class DapAttenteGridController {
	/* @ngInject */
	constructor(
		$scope,
		$state,
		$stateParams,
		$translate,
		ModalService,
		PaginationService,
		DAPsService,
		notification,
		$uibModal,
		$transitions,
		DomainesService,
		moment
	) {
		this.$scope = $scope;
		this.$state = $state;
		this.$stateParams = $stateParams;
		this.$translate = $translate;
		this.ModalService = ModalService;
		this.PaginationService = PaginationService;
		this.DAPsService = DAPsService;
		this.DomainesService = DomainesService;
		this.notification = notification;
		this.$uibModal = $uibModal;
		this.$transitions = $transitions;
		this.loading = false;
		this.allDaps = [];
		this.daps = [];
		this.isDomainPortailActif = false;
		this.isDomainPortailDapActif = false;
		this.noDapMessage = 'DAPS.ATTENTE.NO_DAP';
		this.moment = moment;
		this.demandeurs = [];
		this.selectedDemandeur = null;
		this.sitesAccueil = [];
		this.selectedSiteAccueil = null;
		this._storageKey = 'dap-attente-filters';
	}

	async $onInit() {
		this.loading = true;
		this.isDomainPortailActif = await this.DomainesService.isDomainActif('Portail');
		this.isDomainPortailDapActif = await this.DomainesService.isDomainActif('PortailDAP');
		if (!this.isDomainPortailActif && !this.isDomainPortailDapActif) this.noDapMessage = 'DAPS.ATTENTE.NO_DOMAIN_AT_ALL';
		else if (this.isDomainPortailActif && !this.isDomainPortailDapActif)
			this.noDapMessage = 'DAPS.ATTENTE.NO_PORTAIL_DAP_DOMAIN_WITH_PORTAIL_DOMAIN';

		if (this.isDomainPortailActif && this.isDomainPortailDapActif) {
			let daps = await this.DAPsService.GetDapAttenteListByDemandeur();
			this.allDaps = daps.sort((a, b) => b.id - a.id);
			this.rebuildFilters();
			this.restoreFilters();
			this.applyFilter();
		}
		this.loading = false;
	}

	reset() {
		this.selectedDemandeur = null;
		this.selectedSiteAccueil = null;
		this.rebuildFilters();
		localStorage.removeItem(this._storageKey);
		this.applyFilter();
	}

	uniqueSort(arr) {
		return [...new Set(arr.filter(Boolean))].sort();
	}

	filterDemandeur(daps) {
		return this.uniqueSort(daps.map((d) => d.siteDemandeur?.nomSociete));
	}

	filterAccueil(daps) {
		return this.uniqueSort(daps.flatMap((d) => (d.siteAccueil || []).map((s) => s.nomSociete)));
	}

	rebuildFilters() {
		this.demandeurs = this.filterDemandeur(this.allDaps);
		this.sitesAccueil = this.filterAccueil(this.allDaps);
	}

	saveFilters() {
		localStorage.setItem(this._storageKey, JSON.stringify({ demandeur: this.selectedDemandeur, siteAccueil: this.selectedSiteAccueil }));
	}

	restoreFilters() {
		try {
			const saved = JSON.parse(localStorage.getItem(this._storageKey));
			if (!saved) return;
			if (saved.demandeur && this.demandeurs.includes(saved.demandeur)) this.selectedDemandeur = saved.demandeur;
			if (saved.siteAccueil && this.sitesAccueil.includes(saved.siteAccueil)) this.selectedSiteAccueil = saved.siteAccueil;

			if (this.selectedDemandeur) {
				const filtered = this.allDaps.filter((d) => d.siteDemandeur?.nomSociete === this.selectedDemandeur);
				this.sitesAccueil = this.filterAccueil(filtered);
				if (this.selectedSiteAccueil && !this.sitesAccueil.includes(this.selectedSiteAccueil)) this.selectedSiteAccueil = null;
			} else if (this.selectedSiteAccueil) {
				const filtered = this.allDaps.filter((d) => (d.siteAccueil || []).some((s) => s.nomSociete === this.selectedSiteAccueil));
				this.demandeurs = this.filterDemandeur(filtered);
			}
		} catch (ex) {
			//console.log(ex);
		}
	}

	applyFilter() {
		let result = this.allDaps;
		if (this.selectedDemandeur) result = result.filter((d) => d.siteDemandeur?.nomSociete === this.selectedDemandeur);
		if (this.selectedSiteAccueil) result = result.filter((d) => (d.siteAccueil || []).some((s) => s.nomSociete === this.selectedSiteAccueil));
		this.daps = result;
	}

	changeDemandeur() {
		const filtered = this.selectedDemandeur ? this.allDaps.filter((d) => d.siteDemandeur?.nomSociete === this.selectedDemandeur) : this.allDaps;
		this.sitesAccueil = this.filterAccueil(filtered);
		if (this.selectedSiteAccueil && !this.sitesAccueil.includes(this.selectedSiteAccueil)) this.selectedSiteAccueil = null;
		this.saveFilters();
		this.applyFilter();
	}

	changeSiteAccueil() {
		const filtered = this.selectedSiteAccueil
			? this.allDaps.filter((d) => (d.siteAccueil || []).some((s) => s.nomSociete === this.selectedSiteAccueil))
			: this.allDaps;
		this.demandeurs = this.filterDemandeur(filtered);
		if (this.selectedDemandeur && !this.demandeurs.includes(this.selectedDemandeur)) this.selectedDemandeur = null;
		this.saveFilters();
		this.applyFilter();
	}

	async selectDAP(dap) {
		this.DAPsService.currentDAPAttente = dap;
		this.$state.go('daps.attente', { id: dap.id });
	}
}
